import { computed } from '@angular/core';
import { InterpolationParameters } from '@ngx-translate/core/lib/translate.service';

import { useI18n } from './i18n';

export const injectTranslation = (key: string | string[], interpolateParams?: InterpolationParameters) => {
    const i18n = useI18n();

    return computed(() => i18n().t(key, interpolateParams));
};
